import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg123FLogoHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_2",
	"data-name": "Layer 2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 346.91 43.21",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    " }) }), /* @__PURE__ */ _jsx("g", {
		id: "Layer_1-2",
		"data-name": "Layer 1",
		children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M77.2,43.21c-9.2,0-16.68-7.48-16.68-16.68,0-2.84,2.3-5.14,5.14-5.14s5.14,2.3,5.14,5.14c0,3.53,2.87,6.4,6.4,6.4s6.4-2.87,6.4-6.4c0-2.84,2.3-5.14,5.14-5.14s5.14,2.3,5.14,5.14c0,9.2-7.48,16.68-16.68,16.68Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M76.42,21.24c-1.35,0-2.69-.53-3.7-1.57-1.97-2.04-1.91-5.3.13-7.27l1.41-1.36h-8.41c-2.84,0-5.14-2.3-5.14-5.14s2.3-5.14,5.14-5.14h21.16c2.1,0,3.98,1.27,4.77,3.22.78,1.94.31,4.17-1.2,5.63l-10.58,10.2c-1,.96-2.28,1.44-3.57,1.44Z"
			})] }),
			/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M52.88,21.99c-2.84,0-5.14-2.3-5.14-5.14,0-3.53-2.87-6.4-6.4-6.4s-6.4,2.87-6.4,6.4c0,2.84-2.3,5.14-5.14,5.14s-5.14-2.3-5.14-5.14C24.66,7.65,32.14.17,41.34.17s16.68,7.48,16.68,16.68c0,2.84-2.3,5.14-5.14,5.14Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M52.7,42.61h-21.16c-2.1,0-3.98-1.27-4.77-3.22-.78-1.94-.31-4.17,1.2-5.63l10.58-10.2c2.05-1.97,5.3-1.91,7.27.13s1.91,5.3-.13,7.27l-1.41,1.36h8.41c2.84,0,5.14,2.3,5.14,5.14s-2.3,5.14-5.14,5.14Z"
			})] }),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M15.35,42.92c-2.84,0-5.14-2.3-5.14-5.14v-19.43l-1.36,1.41c-1.97,2.04-5.23,2.1-7.27.13s-2.1-5.23-.13-7.27L11.64,2.03c1.46-1.51,3.68-1.98,5.63-1.2,1.94.79,3.22,2.67,3.22,4.77v32.17c0,2.84-2.3,5.14-5.14,5.14Z"
			})
		] }), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M106.39,42.92c-3.12,0-5.56-2.47-5.56-5.62V6.36c0-3.15,2.39-5.62,5.44-5.62h16.19c2.84,0,5.15,2.29,5.15,5.09s-2.31,5.09-5.15,5.09h-10.4s0,6.99,0,6.99h8.77c2.78,0,5.04,2.23,5.04,4.98s-2.26,4.98-5.04,4.98h-8.77s0,9.41,0,9.41c0,3.15-2.49,5.62-5.68,5.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M136.21,42.62c-3.12,0-5.56-2.47-5.56-5.62V6.02c0-3.12,2.47-5.56,5.62-5.56s5.62,2.44,5.62,5.56v26.42s10.11,0,10.11,0c2.94,0,5.15,2.19,5.15,5.09s-2.26,5.09-5.15,5.09h-15.79Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M177.29,43.21c-12.4,0-21.76-9.25-21.76-21.52S164.89.16,177.29.16s21.7,9.25,21.7,21.52-9.33,21.52-21.7,21.52ZM177.29,10.47c-4.9,0-10.17,3.51-10.17,11.21s5.27,11.22,10.17,11.22c5.95,0,10.11-4.61,10.11-11.22s-4.16-11.21-10.11-11.21Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M255.85,42.46c-3.05,0-5.45-2.44-5.45-5.56V6.2c0-3.15,2.39-5.62,5.45-5.62h16.95c2.89,0,5.15,2.26,5.15,5.15s-2.22,5.04-5.15,5.04h-11.16s0,5.77,0,5.77h9.41c2.75,0,4.98,2.18,4.98,4.86s-2.23,4.86-4.98,4.86h-9.41s0,6,0,6h11.8c2.94,0,5.15,2.17,5.15,5.04s-2.26,5.15-5.15,5.15h-17.59Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M309.62,42.75c-1.84,0-3.39-.8-4.73-2.46l-9.56-11.87h-1.64s0,8.71,0,8.71c0,3.15-2.49,5.62-5.68,5.62s-5.56-2.47-5.56-5.62V6.03c0-2.95,2.52-5.44,5.5-5.44h9.55c10.76,0,15.58,6.89,15.58,13.72,0,4.79-2.26,8.9-6.24,11.47l6.6,7.47c.85.99,1.62,2.15,1.62,4.01,0,3.03-2.44,5.5-5.44,5.5ZM296.74,18.7c2.19,0,4.81-.67,4.81-3.88s-2.61-4.05-4.81-4.05h-3.06s0,7.93,0,7.93h3.06Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M331.51,42.93c-4.04,0-8.41-1.24-11.68-3.32-1.43-.94-3.32-2.5-3.32-5.33s2.26-5.04,5.15-5.04c1.63,0,2.85.72,4.07,1.53,1.72,1.07,3.39,1.97,6.13,1.97,2.42,0,4.05-1.04,4.05-2.59,0-1.48-1.86-2.23-4.89-3.32-.5-.18-1.02-.37-1.54-.57-5.98-2.28-11.51-5.45-11.51-13.18S323.74,0,332.67,0c3.95,0,6.88.58,9.21,1.82,2.33,1.17,3.69,3.02,3.69,5.08,0,2.86-2.03,5.09-4.63,5.09-1.32,0-2.41-.43-3.21-.74l-.23-.09c-1.4-.5-2.87-1.03-4.78-1.03-2.25,0-3.7.9-3.7,2.3,0,1.71,2.01,2.52,5.57,3.82l1.14.42c5.8,2.14,11.17,5.19,11.17,12.95s-6.05,13.31-15.41,13.31Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M238.74,42.75c-3.11,0-4.71-1.49-6.14-3.73l-9.23-14.51-9.07,14.5c-1.63,2.59-3.42,3.74-5.8,3.74-3.41,0-6.08-2.7-6.08-6.14V5.91c0-3.15,2.44-5.62,5.56-5.62s5.56,2.47,5.56,5.62v15.62s4.56-6.92,4.56-6.92c1.51-2.24,3.38-3.36,5.55-3.36s3.96,1.13,5.43,3.37l4.5,6.69V5.91c0-3.2,2.39-5.62,5.56-5.62s5.5,2.42,5.5,5.62v30.7c0,3.5-2.54,6.14-5.91,6.14Z"
			})
		] })] })
	})]
});
export default Svg123FLogoHorizontal;
